export const useOrigin = (): string => {
  const runtimeConfig = useRuntimeConfig();
  const SITE_URL = import.meta.server
    ? runtimeConfig.SITE_URL
    : runtimeConfig.public.SITE_URL;

  if (typeof SITE_URL === 'string' && SITE_URL) {
    return SITE_URL.replace(/\/$/, '');
  }

  const requestUrl = useRequestURL();
  const headers = useRequestHeaders(['x-forwarded-proto', 'x-forwarded-host']);

  const proto = headers['x-forwarded-proto']?.split(',')[0]?.trim();
  const host = headers['x-forwarded-host']?.split(',')[0]?.trim();

  if (proto && host) {
    return `${proto}://${host}`;
  }

  return requestUrl.origin;
};
